import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  selector: 'app-validate',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './validate.component.html',
  styleUrl: './validate.component.scss'
})
export class ValidateComponent {
  status: 'loading' | 'success' | 'error' = 'loading';
  token: any;
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.token = params.get('token') || undefined;
      setTimeout(
        () => {
          if (this.token) {
            this.authService.verifyAccount(this.token).subscribe({
              next: () => {
                this.status = 'success';
              },
              error: () => {
                this.status = 'error';
              }
            });
          } else {
            this.status = 'error';
          }
        }, 1000
      );
    });
  }
}
